/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Whether it took effect.
 */
export type VehicleAuditEventDtoOutcome = typeof VehicleAuditEventDtoOutcome[keyof typeof VehicleAuditEventDtoOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleAuditEventDtoOutcome = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
} as const;
